import {JdDyFormOptionItem} from "./dy-form.interface";
import {AbstractControl} from "@angular/forms";


export function getPlaceHolder(item: JdDyFormOptionItem) {
  let ph = item.placeHolder;
  const label = item.label, type = item.type;
  if (ph || ph === '' || ph === null) {
    return ph ? ph : '';
  }
  if (type === 'input') {
    return `è¯·è¾å¥ ${label ? label : ''}`;
  } else if (type === 'select') {
    return `${item.selectConfig.type === "loadSelect" || item.selectConfig.type === "searchSelect" ?
      'è¯·è¾å¥' + (label ? label : '') + 'è¿è¡æç´¢' : 'è¯·éæ©' + (label ? label : '')}`;
  } else if (type === 'datePicker') {
    return `è¯·éæ©${(label ? label : '')}æ¥æ`;
  } else if (type === 'tableSelect') {
    return `è¯·éæ©${(label ? label : '')}`;
  } else {
    return `${label}`;
  }
}


export function keyCode($event: KeyboardEvent): number {
  let keyCode = 0;
  if ($event.key !== undefined) {
    keyCode = +$event.key;
  } else if ($event.keyCode !== undefined) {
    keyCode = +$event.key;
  }
  return keyCode;
}

export function getFormVaildError(formControl: AbstractControl, name: string) {
  const error =
    formControl.dirty &&
    formControl.hasError('required') &&
    !formControl.getError(name)
      ? 'å¿å¡«å­æ®µ'
      : formControl.dirty && formControl.getError(name)
      ? formControl.getError(name)
      : '';
  if (!error) {
  }
  return error;
}

export const CUSTOM_HELP_MAP = {
  label: {
    customRefs: '_customLabels',
    controlName: 'jdCustomLabelRef',
    directiveName: '*jdCustomLabelRef',
    errorInfoTemp: `<jd-form-label *jdCustomLabelRef="'$value'; let config">{{config.label}}</jd-form-label>`,
    outlet: '_customLabelOutlets',
    outletName: 'jdCustomLabelOutlet'
  },
  control: {
    customRefs: '_customControls',
    // æ§ä»¶åç§°
    controlName: 'jdCustomControlRefName',
    // æä»¤åç§°
    directiveName: '*jdCustomControlRef',
    errorInfoTemp: `<jd-input-group [addOnAfter]="'CBM'" *jdCustomControlRef="let control; let config = config; name: '$value'">
    <input jd-input [formControl]="control" placeholder="placeholder">
  </jd-input-group>`,
    // æåº§
    outlet: '_customControlOutlets',
    outletName: 'jdCustomControlOutlet'
  }
};
